export default "__VITE_ASSET__4dd102a2__"